import { Component } from "react";

/**
 * Rete di sicurezza: cattura gli errori di rendering dei figli e mostra un
 * messaggio leggibile invece di una pagina vuota/nera. Mostra anche il dettaglio
 * tecnico dell'errore (utile per diagnosticare i bug solo-in-produzione).
 * Si resetta quando cambia la rotta (via `resetKey`).
 */
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // Resta nei log del browser per la diagnosi.
        console.error("[ErrorBoundary]", error, info?.componentStack);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
            this.setState({ hasError: false, error: null });
        }
    }

    render() {
        if (!this.state.hasError) return this.props.children;
        const msg = this.state.error?.message || String(this.state.error || "Errore sconosciuto");
        return (
            <div className="max-w-3xl mx-auto px-4 py-20" data-testid="error-boundary">
                <div className="op-card p-8 text-center">
                    <div className="op-label text-tff3b30">// SI È VERIFICATO UN ERRORE</div>
                    <h1 className="op-heading text-3xl mt-3 mb-2 text-tffffff">
                        Questa pagina non si è caricata
                    </h1>
                    <p className="text-tc9ccd3 text-sm mb-5">
                        Riprova a ricaricare. Se il problema continua, mandaci il messaggio qui sotto.
                    </p>
                    <pre
                        className="op-mono text-[11px] text-tff8a80 bg-t1a1d24 border border-tff3b30/30 p-3 mb-6 whitespace-pre-wrap break-words text-left"
                        data-testid="error-boundary-message"
                    >
                        {msg}
                    </pre>
                    <div className="flex items-center justify-center gap-3 flex-wrap">
                        <button
                            onClick={() => window.location.reload()}
                            className="op-btn inline-flex border-t2bb6ff text-t2bb6ff hover:bg-t2bb6ff hover:text-black transition-colors"
                            data-testid="error-boundary-reload"
                        >
                            ↻ Ricarica la pagina
                        </button>
                        <a
                            href="/"
                            className="op-btn inline-flex"
                            data-testid="error-boundary-home"
                        >
                            ← Torna alla Home
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
